module.exports = __webpack_public_path__ + "img/plan-1.545dfb6b.png";